// extracted by mini-css-extract-plugin
export default {"map":"leaflet-map_map__sutyY","icon":"leaflet-map_icon__feGl8"};